/**
 * Status dot + label.
 *
 * Saturated green and red are **reserved for change and status** — they are never
 * a brand colour and never a data series colour (design-system/DECISIONS.md).
 *
 * The label is always rendered alongside the dot: status is never carried by
 * colour alone, which is a WCAG 2.1 AA requirement and one of the three
 * affordances the coverage strip will need in Phase 8.
 */

export type StatusState = 'good' | 'warning' | 'serious' | 'critical' | 'idle'

const TOKEN: Record<StatusState, string> = {
  good: '--status-good',
  warning: '--status-warning',
  serious: '--status-serious',
  critical: '--status-critical',
  idle: '--status-idle',
}

export function StatusDot({
  state,
  children,
}: {
  state: StatusState
  children: React.ReactNode
}) {
  return (
    <span className="inline-flex items-center gap-2">
      <span
        aria-hidden="true"
        style={{
          width: '0.5rem',
          height: '0.5rem',
          borderRadius: '999px',
          background: `var(${TOKEN[state]})`,
          flex: '0 0 auto',
        }}
      />
      <span>{children}</span>
    </span>
  )
}
